
const DeveloperAccount =({
    method,
  countryFlags,
  countryNames,
  commissionsBusiness,
  paymentMethodsByCountry,
  setPaymentMethodsByCountry,
  editingCountryCB,
  setEditingCountryCB,
  editingMethodCB,
  setEditingMethodCB,
  defaultPaymentMethods,
  loadingCommissionBusiness,
  handleSaveOneLineBusiness,
  setModalContextCB,
  setIsModalOpenCB,
  setModalPosition})=>{
    return (
<>
{method.countryPaymentMethods?.length > 0 ? (
            method.countryPaymentMethods.map((country, cIndex) => {
              return (
                <div key={cIndex} style={{ width: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <img
                      src={countryFlags[country.country] || "/default-flag.png"}
                      alt="flag"
                      style={{ width: "22px", height: "22px", objectFit: "contain" }}
                    />
                    <span style={{ margin: "10px", fontFamily: "Poppins", fontSize: "15px", color: "#000" }}>
                      {country.name || countryNames[country.country] || country.country}
                    </span>
                  </div>

                  {country.paymentMethods?.length > 0 ? (
                    <ul style={{ paddingLeft: 0, listStyle: "none" }}>
                      {country.paymentMethods.map((m, i) => {
                       const commissionForCountry = commissionsBusiness[method.id]?.find(c => c.country === country.country);
                  const matchingCommission = commissionForCountry?.paymentMethods?.find(pm =>
                  String(pm.paymentMethod).trim() === String(m.id).trim()
                );
                const defaultMethod = defaultPaymentMethods[m.id] || { payInCommission: 0, payOutCommission: 0, cardCommissionPercentage:0 };
                const isCard = m.id === "CARD";
                const cardCommission =
                m.id === "CARD"
                ? commissionForCountry?.cardCommissionPercentage ?? defaultMethod?.cardCommissionPercentage ?? 0
               : null;
                        return (
                          <li
                            key={i}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                               {isCard ? (
                                <span
                                  style={{
                                    width: "31px",
                                    height: "31px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                  }}
                                >
                                  <span style={{ fontSize: "31px" }}>💳</span>
                                 
                                </span>
                              ) : (
                                <img
                                  src={m?.urlLogo || "/default-flag.png"}
                                  alt={m?.name}
                                  style={{
                                    width: "31px",
                                    height: "31px",
                                    borderRadius: "50%",
                                    objectFit: "contain"
                                  }}
                                />
                                )}
                              <span style={{ fontFamily: "Poppins", fontSize: "14px", color: "#333" }}>{m?.name}</span>
                            </div>      
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        marginLeft: "auto",
                      }}
                    >
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <label
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                    color: "#2A2A2A",
                    minWidth: "55px",
                  }}
                >
                  {m.id === "CARD" ? "Commission carte  :" : "PayIn :"}
                </label>
                <input
  type="number"
value={
  m.id === "CARD"
    ? paymentMethodsByCountry[country.country]?.[i]?.cardCommissionPercentage
      ?? cardCommission
    : paymentMethodsByCountry[country.country]?.[i]?.payinCommissionPercentage
      ?? matchingCommission?.payinCommissionPercentage
      ?? defaultMethod?.payInCommission
      ?? ""
}
  onChange={(e) => {
    const updated = [
      ...(paymentMethodsByCountry[country.country] || country.paymentMethods),
    ];
  updated[i] = {
      ...updated[i],
      ...(m.id === "CARD"
        ? { cardCommissionPercentage: e.target.value === "" ? 0 : Number(e.target.value) }
        : { payinCommissionPercentage: e.target.value === "" ? 0 : Number(e.target.value) }
      ),
    };
    setPaymentMethodsByCountry((prev) => ({
      ...prev,
      [country.country]: updated,
    }));
  }}
  disabled={!(
    editingCountryCB === country.country &&
    editingMethodCB === (m.id || m.name)
  )}
  className="form-control"
  style={{
    width: "70px",
    border: "1px solid #0000001A",
    borderRadius: "4px",
    textAlign: "center",
    padding: "4px",
    backgroundColor:
      editingCountryCB === country.country ? "#fff" : "#f5f5f5",
  }}
/>
  <span> {country.country === "GH" ? "GHS" : "%"}</span>
  </div>
  {!isCard && (
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <label
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "15px",
                      fontWeight: "400",
                      color: "#2A2A2A",
                      minWidth: "55px",
                    }}
                  >
                  PayOut :
                  </label>
  <input
  type="number"
  value={
    paymentMethodsByCountry[country.country]?.[i]?.payoutCommissionPercentage
    ?? matchingCommission?.payoutCommissionPercentage
    ?? defaultMethod?.payOutCommission
    ?? ""
  }
  onChange={(e) => {
    const updated = [
      ...(paymentMethodsByCountry[country.country] || country.paymentMethods),
    ];

    updated[i] = {
      ...updated[i],
      payoutCommissionPercentage:
        e.target.value === "" ? 0 : Number(e.target.value),
    };

    setPaymentMethodsByCountry((prev) => ({
      ...prev,
      [country.country]: updated,
    }));
  }}
  disabled={!(
    editingCountryCB === country.country &&
    editingMethodCB === (m.id || m.name)
  )}
  className="form-control"
  style={{
    width: "70px",
    border: "1px solid #0000001A",
    borderRadius: "4px",
    textAlign: "center",
    padding: "4px",
    backgroundColor:
      editingCountryCB === country.country ? "#fff" : "#f5f5f5",
  }}
/>
<span>  {country.country === "GH" ? "GHS" : "%"}</span>
</div>
  )}
                
<button
  type="button"
  className="btn btn-primary"
  loading={loadingCommissionBusiness}
onClick={() =>
  handleSaveOneLineBusiness(
    method.id,
    country.country,
    {
      paymentMethod: m.id || m.name,

      payinCommissionPercentage:
        paymentMethodsByCountry[country.country]?.[i]?.payinCommissionPercentage
        ?? matchingCommission?.payinCommissionPercentage
        ?? defaultMethod?.payInCommission
        ?? 0,
      payoutCommissionPercentage:
        paymentMethodsByCountry[country.country]?.[i]?.payoutCommissionPercentage
        ?? matchingCommission?.payoutCommissionPercentage
        ?? defaultMethod?.payOutCommission
        ?? 0,

      cardCommissionPercentage:
        paymentMethodsByCountry[country.country]?.[i]?.cardCommissionPercentage
        ?? commissionForCountry?.cardCommissionPercentage
        ?? defaultMethod?.cardCommissionPercentage
        ?? 0
    }
  )
}
  disabled={!(editingCountryCB === country.country && editingMethodCB === (m.id || m.name))}
>
  Enregistrer
</button>
<div style={{ display: "flex", justifyContent: "flex-end",marginLeft:"10px" }}>
  <div
  onClick={(e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    e.stopPropagation();
    setModalContextCB({ country: country.country, method: m, index: i }); // stocke infos
    setIsModalOpenCB(true);
    setModalPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX - 100 });
  }}
  style={{
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    cursor: "pointer",
    border: "1px solid #00000014",
  }}
>
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="6" r="2" fill="#21272A" />
    <circle cx="12" cy="12" r="2" fill="#21272A" />
    <circle cx="12" cy="18" r="2" fill="#21272A" />
  </svg>
</div> 
</div>
</div>
  </li>
  );
  })}
 </ul>
  ) : (
  <div style={{ fontStyle: "italic", color: "#888" }}>Aucune méthode de paiement disponible</div>
  )}
  </div>
   );
  })
  ) : (
 <div style={{ fontStyle: "italic", color: "#888" }}>Aucune méthode disponible</div>
  )}
  </>
);
}
export default DeveloperAccount;